var _defs, _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBronzeMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 23.66,
    viewBox: "0 0 14 23.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#913200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#f89d59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d3802e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#923201"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_58297",
    "data-name": "Group 58297",
    transform: "translate(-689.37 -23.34)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58292",
    "data-name": "Group 58292",
    transform: "translate(689.37 23.34)",
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_42186",
    "data-name": "Path 42186",
    d: "M15.667,2H6.333A2.333,2.333,0,0,0,4,4.333V6.667A2.333,2.333,0,0,0,5.522,8.842l4.667,1.7.2.058v.828c-1.794.3,2.961.3,1.167,0v-.875l.2-.058,4.667-1.7A2.333,2.333,0,0,0,18,6.62V4.333A2.333,2.333,0,0,0,15.667,2Zm1.167,4.62A1.167,1.167,0,0,1,16.081,7.7L11.414,9.4a1.126,1.126,0,0,1-.782,0L5.966,7.7a1.167,1.167,0,0,1-.8-1.079V4.333A1.167,1.167,0,0,1,6.333,3.167h9.333a1.167,1.167,0,0,1,1.167,1.167Z",
    transform: "translate(-4 -2)",
    fill: "#1b2737"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_42187",
    "data-name": "Path 42187",
    d: "M13.917,6a.583.583,0,0,0-.583.583V8.917a.583.583,0,0,0,1.167,0V6.583A.583.583,0,0,0,13.917,6ZM16.25,6a.583.583,0,0,0-.583.583V8.917a.583.583,0,1,0,1.167,0V6.583A.583.583,0,0,0,16.25,6ZM11.583,6A.583.583,0,0,0,11,6.583V8.917a.583.583,0,0,0,1.167,0V6.583A.583.583,0,0,0,11.583,6Z",
    transform: "translate(-6.917 -3.667)",
    fill: "#1b2737"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58282",
    "data-name": "Group 58282",
    transform: "translate(689.37 33)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_493",
    "data-name": "Ellipse 493",
    cx: 7,
    cy: 7,
    r: 7,
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_498",
    "data-name": "Ellipse 498",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(3 3)",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBronzeMedal);
export default __webpack_public_path__ + "static/media/bronzeMedal.a04615ccd32f1be584dad58e91a0c48d.svg";
export { ForwardRef as ReactComponent };